import { ConvertableFromApi } from "../models/ConvertableFromApi";
import {ajaxGetFileByPost} from "../data/ajax";

export class WorkspaceItem extends ConvertableFromApi<WorkspaceItem> {
    metadata!: string;
    name!: string;
    uri!: string;
    blobType!: number;
    selected!: boolean;
  
  constructor(data?: any) {
    super(data);

    if(!this.objectFromApi){
      return;
    }
    
    this.metadata = this.objectFromApi.metadata;
    this.name = this.objectFromApi.name;
    this.uri = this.objectFromApi.uri;
    this.blobType = this.objectFromApi.blobType;
    this.selected = false;
  }

  createNew(element: any): WorkspaceItem {
    return new WorkspaceItem(element);
  }

  async downloadItem(resourceGroup: string, storageAccount: string, container: string, subscriptionId: string, token: string){
    const url = process.env.VUE_APP_ROOT_API + `Workspace/download`;
    var body = {
      ResourceGroup: resourceGroup,
      StorageAccount: storageAccount,
      Container: container,
      FileName: this.name,
      SubscriptionId: subscriptionId
    }
    var file = await ajaxGetFileByPost(url, token, body);
    if(file !== null){
        var a = document.createElement('a');
        var url2 = window.URL.createObjectURL(file);
        a.href = url2;
        a.download = `${this.name}`;
        a.click();
        window.URL.revokeObjectURL(url);
    }
  }
}
